<template>
  <div>
    <div class="occurrences">
      <h6 class="legam-h6 with-line">
        Occurrences
        <span class="show-more-info">
          <b-form-checkbox
            :id="'show-details-on-occurrences-' + objectType + objectId"
            v-model="showDetailsOnOccurrences"
            name="show-details-on-occurrences"
            switch
            size="sm"
            class="float-right"
          >
            Show more info
          </b-form-checkbox>
        </span>
      </h6>

      <b-form-checkbox-group
        v-model="selectedOccurrences"
      >
        <ul class="occurrences occurrences-ul">
          <li v-for="occurrence in sortedOccurrences" :key="occurrence.id">
            <b-form-checkbox :value="occurrence._occurrenceType + '|' + occurrence.id" v-if="config.editable">
            <!-- <b-form-checkbox :value="occurrence.id" class="custom-checkbox"> -->
              <LemmaEditOccurrence
                v-if="occurrence._occurrenceType == 'occurrence'"
                :occurrence="occurrence"
                :type="objectType"
                :lemmaId="lemmaId"
                :showDetails="showDetailsOnOccurrences"
                :disableEdit="disableEdit"
                @remove="removeOccurrence"
                @change="changeOccurrence"
                @showDetails="showOccurrenceReferenceDetails"
                :dictionaryId="dictionaryId"
              />
              <LemmaEditOccurrence
                v-else
                :occurrence="occurrence"
                :type="objectType"
                :lemmaId="lemmaId"
                :showDetails="showDetailsOnOccurrences"
                :disableEdit="disableEdit"
                @remove="removeContainerOccurrence"
                @change="changeContainerOccurrence"
                @showDetails="showOccurrenceReferenceDetails"
              />
            </b-form-checkbox>
            <template v-else>
              <LemmaEditOccurrence
                v-if="occurrence._occurrenceType == 'occurrence'"
                :occurrence="occurrence"
                :type="objectType"
                :lemmaId="lemmaId"
                :showDetails="showDetailsOnOccurrences"
                :disableEdit="disableEdit"
                @remove="removeOccurrence"
                @change="changeOccurrence"
                @showDetails="showOccurrenceReferenceDetails"
                :dictionaryId="dictionaryId"
              />
              <LemmaEditOccurrence
                v-else
                :occurrence="occurrence"
                :type="objectType"
                :lemmaId="lemmaId"
                :showDetails="showDetailsOnOccurrences"
                :disableEdit="disableEdit"
                @remove="removeContainerOccurrence"
                @change="changeContainerOccurrence"
                @showDetails="showOccurrenceReferenceDetails"
              />
            </template>
          </li>
        </ul>
        <b-button @click="toggleAllSelect('occurrences')" size="sm" class="ml-1">{{ selectedOccurrences.length == occurrences.length ? 'Deselect ' : 'Select '}} all</b-button>
        <div v-if="selectedOccurrences.length && disableEdit != true" class="mt-2">
          <b-button @click="moveToLemma('occurrences', selectedOccurrences, objectId)" size="sm">Move to lemma</b-button>
          <b-button @click="moveToSenseProtospelling('occurrences', selectedOccurrences, objectId)" size="sm" class="ml-1">Move to {{ objectType }}</b-button>
          <template v-if="dictionaryId">
            <b-button size="sm" @click="toggleSuppression('occurrences', selectedOccurrences, true)" class="ml-1">Suppress</b-button>
            <b-button size="sm" @click="toggleSuppression('occurrences', selectedOccurrences, false)" class="ml-1">Unsuppress</b-button>
          </template>
          <b-button variant="light" @click="removeSelected('occurrences')" class="ml-1" size="sm">Remove all selected occurrences</b-button>
        </div>
      </b-form-checkbox-group>
    </div>
    <div class="references mt-5">
      <h6 class="legam-h6 with-line">
        References
        <span class="show-more-info">
          <b-form-checkbox
            :id="'show-details-on-references-' + objectType + objectId"
            v-model="showDetailsOnReferences"
            name="show-details-on-references"
            switch
            size="sm"
            class="float-right"
          >
            Show more info
          </b-form-checkbox>
        </span>
      </h6>
      <b-form-checkbox-group
        v-model="selectedReferences"
      >
        <ul class="occurrences occurrences-ul">
          <li v-for="reference in x_references" :key="reference.id">
            <b-form-checkbox :value="reference.id" v-if="config.editable">
              <LemmaEditReference
                :reference="reference"
                :type="objectType"
                :lemmaId="lemmaId"
                :showDetails="showDetailsOnReferences"
                :disableEdit="disableEdit"
                @remove="removeReference"
                @showDetails="showOccurrenceReferenceDetails"
                @change="changeReference"
                :dictionaryId="dictionaryId"
              />
            </b-form-checkbox>
          </li>
        </ul>
        <b-button @click="toggleAllSelect('references')" size="sm" class="ml-1">{{ selectedReferences.length == references.length ? 'Deselect ' : 'Select '}} all</b-button>
        <div v-if="selectedReferences.length && disableEdit != true" class="mt-2">
          <b-button @click="moveToLemma('references', selectedReferences, objectId)" size="sm">Move to lemma</b-button>
          <b-button @click="moveToSenseProtospelling('references', selectedReferences, objectId)" size="sm" class="ml-1">Move to {{ objectType }}</b-button>
          <template v-if="dictionaryId">
            <b-button size="sm" @click="toggleSuppression('references', selectedReferences, true)" class="ml-1">Suppress</b-button>
            <b-button size="sm" @click="toggleSuppression('references', selectedReferences, false)" class="ml-1">Unsuppress</b-button>
          </template>
          <b-button variant="light" @click="removeSelected('references')" class="ml-1" size="sm">Remove all selected references</b-button>
        </div>
      </b-form-checkbox-group>
    </div>
  </div>
</template>

<style scoped>
  div.occurrences {
    margin-bottom: -26px;
  }
  .show-more-info > div {
    margin-top: -7px;
  }
  * >>> .show-more-info .custom-control-label {
    text-transform: none;
  }
  .custom-control {
    position: unset !important;
  }
</style>>

<script>
  import Utils from '@/utils.js'
  import LemmaEditOccurrence from '@/components/Lemma/EditOccurrence.vue'
  import LemmaEditReference from '@/components/Lemma/EditReference.vue'
  import config from '@/config.js'
  import axios from 'axios'

  export default {
    name: 'LemmaEditOccurrences',
    props: ['occurrences', 'containerOccurrences', 'references', 'objectType', 'objectId', 'lemmaId', 'dictionaryId', 'disableEdit'],
    data(){
      return {
        x_occurrences: this.occurrences,
        x_containerOccurrences: this.containerOccurrences,
        x_references: Utils.sortOccurrencesReferences(this.references, 'form'),
        showDetailsOnOccurrences: false,
        showDetailsOnReferences: false,
        selectedOccurrences: [],
        selectedReferences: [],
        config: config,
      }
    },
    components: {
      LemmaEditOccurrence,
      LemmaEditReference
    },
    computed: {
      sortedOccurrences(){
        let occurrences = this.occurrences.concat(this.containerOccurrences)
        return Utils.sortOccurrencesReferences(occurrences, 'form')
      }
    },
    watch: {
      containerOccurrences() {
        this.x_containerOccurrences = this.containerOccurrences
      },
      occurrences() {
        this.x_occurrences = this.occurrences
      },
      references() {
        this.x_references = Utils.sortOccurrencesReferences(this.references, 'form')
      }
    },
    methods: {
      toggleAllSelect(object) {
        if (object == 'occurrences') {
          if (this.selectedOccurrences.length == this.occurrences.length) {
            this.selectedOccurrences = []
          } else {
            this.selectedOccurrences = this.occurrences.map(occ => occ._occurrenceType + '|' + occ.id)
          }
        } else if (object == 'references') {
          if (this.selectedReferences.length == this.references.length) {
            this.selectedReferences = []
          } else {
            this.selectedReferences = this.references.map(reference => reference.id)
          }
        }
      },
      toggleSuppression(object, selectedItems, toSuppress) {
        if (object === 'occurrences') {
          selectedItems.forEach(item => {
            const [occType, occId] = item.split("|")

            axios
              .post(config.apiUrl + `/occurrence/${occId}/suppression`, {
                dictionaryId: this.dictionaryId,
                suppress: toSuppress,
                occType: occType,
                entity: this.objectType
            })

            this.$emit('occurrenceSuppression', occType, occId, toSuppress, this.objectType)
          })
          this.selectedOccurrences = []
        } else if (object === 'references') {
          selectedItems.forEach(referenceId => {
            axios
              .post(config.apiUrl + `/reference/${referenceId}/suppression`, {
                dictionaryId: this.dictionaryId,
                suppress: toSuppress,
                entity: this.objectType
            })

            this.$emit('referenceSuppression', referenceId, toSuppress, this.objectType)
          })
          this.selectedReferences = []
        }
      },
      moveToLemma(object, selectedItems, objectId){
        if (object === 'occurrences') {
          this.$emit('moveToLemma', selectedItems.map(selected => selected.split("|")[1]), objectId)
          this.selectedOccurrences = []
        } else if (object === 'references') {
          this.$emit('moveToLemma', selectedItems, objectId)
          this.selectedReferences = []
        }
      },
      moveToSenseProtospelling(object, selectedItems, objectId){
        if (object === 'occurrences') {
          this.$emit('moveToSenseProtospelling', selectedItems.map(selected => selected.split("|")[1]), objectId)
          this.selectedOccurrences = []
        } else if (object === 'references') {
          this.$emit('moveToSenseProtospelling', selectedItems, objectId)
          this.selectedReferences = []
        }
      },
      removeSelected(object){
        this.$bvModal.msgBoxConfirm('Are you sure?')
          .then(value => {
            if (value){
              if (object === 'occurrences') {
                this.selectedOccurrences.forEach(obj => {
                  let occurrenceType = obj.split('|')[0]
                  let occurrenceReferenceId = obj.split('|')[1]
                  this.$store.dispatch('deleteOccurrenceReference', {
                    lemmaId: this.lemmaId,
                    occurrenceId: occurrenceReferenceId,
                    type: occurrenceType,
                    objectType: this.objectType,
                    objectId: this.objectId
                  }).then(() => {
                    delete this.x_containerOccurrences[occurrenceReferenceId];
                    this.$forceUpdate();
                  })
                  this.$emit('removeOccurrence', occurrenceReferenceId, this.objectId)
                })
                this.selectedOccurrences = []
              } else if (object === 'references') {
                this.selectedReferences.forEach(referenceId => {
                  this.$store.dispatch('deleteOccurrenceReference', {
                    lemmaId: this.lemmaId,
                    occurrenceId: referenceId,
                    type: 'reference',
                    objectType: this.objectType,
                    objectId: this.objectId
                  }).then(() => {
                    this.x_references = this.x_references.filter(reference => reference.id != referenceId)
                    this.$forceUpdate();
                  })
                  this.$emit('removeReference', referenceId, this.objectId)
                })
                this.selectedReferences = []
              }
            }
          })
      },
      showOccurrenceReferenceDetails(occurrence){
        this.$emit('showOccurrenceReferenceDetails', occurrence)
      },
      removeOccurrence(occurrenceId){
        this.$bvModal.msgBoxConfirm('Are you sure?')
          .then(value => {
            if (value){
              this.$store.dispatch('deleteOccurrenceReference', {
                lemmaId: this.lemmaId,
                occurrenceId: occurrenceId,
                type: 'occurrence',
                objectType: this.objectType,
                objectId: this.objectId
              }).then(() => {
                delete this.x_containerOccurrences[occurrenceId];
                this.$forceUpdate();
              })
              this.$emit('removeOccurrence', occurrenceId, this.objectId)
            }
          })
      },
      removeContainerOccurrence(occurrenceId){
        this.$bvModal.msgBoxConfirm('Are you sure?')
          .then(value => {
            if (value){
              this.$store.dispatch('deleteOccurrenceReference', {
                lemmaId: this.lemmaId,
                occurrenceId: occurrenceId,
                type: 'containeroccurrence',
                objectType: this.objectType,
                objectId: this.objectId
              }).then(() => {
                delete this.x_containerOccurrences[occurrenceId];
                this.$forceUpdate();
              })
              this.$emit('removeOccurrence', occurrenceId, this.objectId)
            }
          })
      },
      removeReference(referenceId){
        this.$bvModal.msgBoxConfirm('Are you sure?')
          .then(value => {
            if (value){
              this.$store.dispatch('deleteOccurrenceReference', {
                lemmaId: this.lemmaId,
                occurrenceId: referenceId,
                type: 'reference',
                objectType: this.objectType,
                objectId: this.objectId
              }).then(() => {
                this.x_references = this.x_references.filter(reference => reference.id != referenceId)
                this.$forceUpdate();
              })
              this.$emit('removeReference', referenceId, this.objectId)
            }
          })
      },
      changeReference(oldReferenceId, newReference){
        this.$store.dispatch('changeOccurrenceReference', {
          lemmaId: this.lemmaId,
          oldReferenceId: oldReferenceId,
          newReferenceId: newReference.id,
          type: 'reference',
          objectType: this.objectType,
          objectId: this.objectId
        }).then(() => {
          this.x_references = this.x_references.filter(reference => reference.id != oldReferenceId)
          this.$forceUpdate();
          this.x_references.push(newReference)
        })
      },
      changeOccurrence(oldOccurrenceId, newOccurrence){
        this.$store.dispatch('changeOccurrenceReference', {
          lemmaId: this.lemmaId,
          oldOccurrenceId: oldOccurrenceId,
          newOccurrenceId: newOccurrence.id,
          type: 'occurrence',
          objectType: this.objectType,
          objectId: this.objectId
        }).then(() => {
          this.x_occurrences = this.x_occurrences.filter(occurrence => occurrence.id != oldOccurrenceId)
          this.$forceUpdate();
          this.x_occurrences.push(newOccurrence)
        })
      },
      changeContainerOccurrence(oldOccurrenceId, newOccurrence){
        this.$store.dispatch('changeOccurrenceReference', {
          lemmaId: this.lemmaId,
          oldOccurrenceId: oldOccurrenceId,
          newOccurrenceId: newOccurrence.id,
          type: 'containteroccurrence',
          objectType: this.objectType,
          objectId: this.objectId
        }).then(() => {
          this.x_containerOccurrences = this.x_containerOccurrences.filter(occurrence => occurrence.id != oldOccurrenceId)
          this.$forceUpdate();
          this.x_containerOccurrences.push(newOccurrence)
        })
      }
    }
  }
</script>
